export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#2d1b4e] to-[#0f0520] text-white pt-16 pb-8 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#ff00ff] rounded-full mix-blend-screen filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/36e200659a4cc97e8ffc8ac4660b08aa/99dc07e31ad03e137a63ec7bb4222661.png"
                alt="Logo Ideas"
                className="w-12 h-12 rounded-full border-2 border-[#00ffff] object-cover shadow-lg shadow-[#00ffff]/50"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-[#ff00ff] via-[#00ffff] to-[#ff00aa] bg-clip-text text-transparent">Logo Ideas</span>
            </div>
            <p className="text-[#c0c0ff] text-sm leading-relaxed">
              Agencia creativa especializada en diseño de logotipos, banners, flyers y contenido para redes sociales.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#00ffff]">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('inicio')} className="text-[#c0c0ff] hover:text-[#00ffff] transition-colors text-sm cursor-pointer">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="text-[#c0c0ff] hover:text-[#00ffff] transition-colors text-sm cursor-pointer">
                  Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portafolio')} className="text-[#c0c0ff] hover:text-[#00ffff] transition-colors text-sm cursor-pointer">
                  Portafolio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonios')} className="text-[#c0c0ff] hover:text-[#00ffff] transition-colors text-sm cursor-pointer">
                  Testimonios
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#00ffff]">Servicios</h4>
            <ul className="space-y-3 text-sm text-[#c0c0ff]">
              <li>Logotipos Profesionales</li>
              <li>Banners Publicitarios</li>
              <li>Flyers Promocionales</li>
              <li>Diseños para Redes Sociales</li>
              <li>Identidad Visual</li>
              <li>Branding Completo</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#00ffff]">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="https://wa.me/527131055034" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#c0c0ff] hover:text-[#00ffff] transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-lg"></i>
                  7131055034
                </a>
              </li>
              <li>
                <a href="mailto:logoideas05@gmail.com" className="flex items-center gap-2 text-[#c0c0ff] hover:text-[#00ffff] transition-colors cursor-pointer break-all">
                  <i className="ri-mail-line text-lg"></i>
                  logoideas05@gmail.com
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/share/1AefDud4bR/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#c0c0ff] hover:text-[#00ffff] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#00ffff]/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#c0c0ff]">
            © 2025 Logo Ideas. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-[#00ffff] hover:text-[#ff00ff] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
